import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverHighlight } from '@/utility/theme/animation';

export const Container = styled.div(() =>
  mq({
    backgroundColor: defaultTheme.background.white,
    padding: [defaultTheme.spacing.l, defaultTheme.spacing.l, 0, 0],
  }),
);

export const Title = styled.h3(() =>
  mq({
    fontSize: [
      defaultTheme.font.size.xl,
      defaultTheme.font.size.xl,
      defaultTheme.font.size.xxl,
      defaultTheme.font.size.xxl,
    ],
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.xxl,
      defaultTheme.spacing.xxl,
    ],
  }),
);

export const ButtonWrapper = styled.div(() =>
  mq({
    textAlign: 'center',
    marginTop: defaultTheme.spacing.s,
  }),
);

export const LinkButton = styled(Link)(() =>
  mq({
    display: 'inline-block',
    fontSize: defaultTheme.font.size.s,
    ...hoverHighlight,
  }),
);
